import { ForwardedRef, forwardRef } from 'react';

export const IconLocation = forwardRef(
  (
    {
      filled,
      ...props
    }: React.SVGProps<SVGSVGElement> & { readonly filled?: boolean },
    ref: ForwardedRef<SVGSVGElement>,
  ) => {
    return (
      <svg
        ref={ref}
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
        {...props}
      >
        {filled ? (
          <path
            fill="currentColor"
            d="M12 11.75c.483 0 .896-.17 1.238-.512.341-.342.512-.755.512-1.238s-.17-.896-.512-1.238A1.686 1.686 0 0012 8.25c-.483 0-.896.17-1.238.512A1.686 1.686 0 0010.25 10c0 .483.17.896.512 1.238.342.341.755.512 1.238.512zM12 22c-2.683-2.283-4.688-4.404-6.013-6.363C4.662 13.68 4 11.867 4 10.2c0-2.5.804-4.492 2.412-5.975C8.021 2.742 9.883 2 12 2s3.98.742 5.587 2.225C19.197 5.708 20 7.7 20 10.2c0 1.667-.663 3.48-1.988 5.438C16.688 17.595 14.683 19.716 12 22z"
          ></path>
        ) : (
          <path
            fill="currentColor"
            d="M12 11.75c.483 0 .896-.17 1.238-.512.341-.342.512-.755.512-1.238s-.17-.896-.512-1.238A1.686 1.686 0 0012 8.25c-.483 0-.896.17-1.238.512A1.686 1.686 0 0010.25 10c0 .483.17.896.512 1.238.342.341.755.512 1.238.512zm0 8.275c2.217-2.017 3.854-3.846 4.913-5.487C17.97 12.896 18.5 11.45 18.5 10.2c0-1.967-.63-3.575-1.887-4.825C15.354 4.125 13.817 3.5 12 3.5c-1.817 0-3.354.625-4.612 1.875C6.129 6.625 5.5 8.233 5.5 10.2c0 1.25.542 2.696 1.625 4.338 1.083 1.641 2.708 3.47 4.875 5.487zM12 22c-2.683-2.283-4.688-4.404-6.013-6.363C4.662 13.68 4 11.867 4 10.2c0-2.5.804-4.492 2.412-5.975C8.021 2.742 9.883 2 12 2s3.98.742 5.587 2.225C19.197 5.708 20 7.7 20 10.2c0 1.667-.663 3.48-1.988 5.438C16.688 17.595 14.683 19.716 12 22z"
          ></path>
        )}
      </svg>
    );
  },
);

IconLocation.displayName = 'IconLocation';

export default IconLocation;
